import { render } from "./startUpAlertView.vue?vue&type=template&id=72920a9b"
import script from "./startUpAlertView.vue?vue&type=script&lang=js"
export * from "./startUpAlertView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__